// The selection toolbar and note editor (src/annotations/).
export const annotationsText = {
  en: {
    toolbar: 'Highlight and note', copy: 'Copy', copied: 'Copied', note: 'Note', editNote: 'Edit note',
    listen: 'Listen', remove: 'Delete', highlight: 'Highlight', underline: 'Underline', wavy: 'Wavy underline',
    colors: { yellow: 'Yellow', green: 'Green', blue: 'Blue', red: 'Red', purple: 'Purple' },
    noteTitle: 'Note', notePlaceholder: 'Write a note…', save: 'Save', cancel: 'Cancel',
    deleteNote: 'Delete note', left: n => `${n} left`, openNote: 'Open note',
    listenFrom: 'Play the recording from this verse', playFromVerse: n => `Play from verse ${n}`,
    followAudio: 'Follow audio',
  },
  es: {
    toolbar: 'Resaltar y anotar', copy: 'Copiar', copied: 'Copiado', note: 'Nota', editNote: 'Editar nota',
    listen: 'Escuchar', remove: 'Eliminar', highlight: 'Resaltar', underline: 'Subrayar', wavy: 'Subrayado ondulado',
    colors: { yellow: 'Amarillo', green: 'Verde', blue: 'Azul', red: 'Rojo', purple: 'Morado' },
    noteTitle: 'Nota', notePlaceholder: 'Escribe una nota…', save: 'Guardar', cancel: 'Cancelar',
    deleteNote: 'Eliminar nota', left: n => `quedan ${n}`, openNote: 'Abrir nota',
    listenFrom: 'Escuchar la grabación desde este versículo', playFromVerse: n => `Escuchar desde el versículo ${n}`,
    followAudio: 'Seguir el audio',
  },
  zh: {
    toolbar: '標記與筆記', copy: '複製', copied: '已複製', note: '筆記', editNote: '編輯筆記',
    listen: '聆聽', remove: '刪除', highlight: '螢光標記', underline: '底線', wavy: '波浪線',
    colors: { yellow: '黃色', green: '綠色', blue: '藍色', red: '紅色', purple: '紫色' },
    noteTitle: '筆記', notePlaceholder: '寫下筆記…', save: '儲存', cancel: '取消',
    deleteNote: '刪除筆記', left: n => `還可輸入 ${n} 字`, openNote: '打開筆記',
    listenFrom: '從這節開始播放錄音', playFromVerse: n => `從第 ${n} 節播放`,
    followAudio: '跟隨音頻',
  },
  sc: {
    toolbar: '标记与笔记', copy: '复制', copied: '已复制', note: '笔记', editNote: '编辑笔记',
    listen: '聆听', remove: '删除', highlight: '荧光标记', underline: '下划线', wavy: '波浪线',
    colors: { yellow: '黄色', green: '绿色', blue: '蓝色', red: '红色', purple: '紫色' },
    noteTitle: '笔记', notePlaceholder: '写下笔记…', save: '保存', cancel: '取消',
    deleteNote: '删除笔记', left: n => `还可输入 ${n} 字`, openNote: '打开笔记',
    listenFrom: '从这节开始播放录音', playFromVerse: n => `从第 ${n} 节播放`,
    followAudio: '跟随音频',
  },
};
